<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PanelTypeListing />

    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PanelTypeListing from "@/views/pages/admin/panelType/panelTypeListing";

export default {
    page: {
        title: i18n.t("module.panelType"),
    },
    components: { Layout, PageHeader, PanelTypeListing },
    data() {
        return {
            title: i18n.t("module.panelType"),
            items: [
                {
                    text: i18n.t("module.vehicle"),
                    href: '/vehicles',
                },
                {
                    text: i18n.t("module.panelType"),
                    active: true,
                },
            ],
        };
    },
}
</script>